import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { PayrollService, PayrollPeriod, PayrollPeriodStatus } from '../../../services/payroll.service';
import { FlagService } from '../../../shared/services/flag.service';
import { FlagType } from '../../../shared/utils/enums';

@Component({
  selector: 'app-payroll-periods',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './payroll-periods.component.html',
  styleUrl: './payroll-periods.component.scss'
})
export class PayrollPeriodsComponent implements OnInit {
  periods: PayrollPeriod[] = [];
  loading = false;
  preparing = false;
  /** yyyy-MM, defaults to the previous month (the one usually being paid). */
  selectedMonth: string;

  constructor(
    private service: PayrollService,
    private router: Router,
    private flag: FlagService
  ) {
    const now = new Date();
    const previous = new Date(now.getFullYear(), now.getMonth() - 1, 1);
    this.selectedMonth = `${previous.getFullYear()}-${String(previous.getMonth() + 1).padStart(2, '0')}`;
  }

  ngOnInit(): void {
    this.load();
  }

  load(): void {
    this.loading = true;
    this.service.listPeriods().subscribe({
      next: (data) => {
        this.periods = data ?? [];
        this.loading = false;
      },
      error: () => {
        this.flag.displayFlag('Erreur lors du chargement des périodes de paie', FlagType.error);
        this.loading = false;
      }
    });
  }

  prepare(): void {
    if (!this.selectedMonth || this.preparing) return;
    this.preparing = true;
    this.service.prepare(this.selectedMonth).subscribe({
      next: (period) => {
        this.flag.displayFlag(`Période ${period.period} préparée`, FlagType.success);
        this.preparing = false;
        this.load();
      },
      error: () => {
        this.flag.displayFlag('Erreur lors de la préparation de la période', FlagType.error);
        this.preparing = false;
      }
    });
  }

  open(period: PayrollPeriod): void {
    this.router.navigate(['/agency/payroll', period.id]);
  }

  statusLabel(status: PayrollPeriodStatus): string {
    switch (status) {
      case 'DRAFT': return 'Brouillon';
      case 'PREPARED': return 'Préparée';
      case 'SENT': return 'Envoyée à Sage';
      case 'PAYSLIPS_RECEIVED': return 'Bulletins reçus';
      case 'CLOSED': return 'Clôturée';
      default: return status;
    }
  }
}
